import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';

import LoginPasswordForm from './components/LoginPasswordForm';
import { useLoginPasswordManager } from './hooks/useLoginPasswordManager';

function LoginPasswordScreen() {
  const { t } = useTranslation('loginPassword');
  useTransactionLocale();

  const { editIdentifierLink } = useLoginPasswordManager();

  useEffect(() => {
    trackPageView('login/password');
  }, []);

  document.title = t('page.title');
  const title = t('heading.title');

  const handleBack = () => {
    // biome-ignore lint/style/noNonNullAssertion: handleBack is only called when editIdentifierLink is truthy (controlled by backCtaProps ternary), so non-null assertion is safe
    window.location.assign(editIdentifierLink!);
  };

  return (
    <BaseWrapper
      title={title}
      backCtaProps={editIdentifierLink ? { onClick: handleBack } : undefined}>
      <LoginPasswordForm />
    </BaseWrapper>
  );
}

export default LoginPasswordScreen;
